/* eslint-disable import/no-anonymous-default-export */
import axios from './BASE_API'
import AuthHeader from './AuthHeader'

// class define
class MarketingService {

    getCampaignDashboardData = () => {
        return axios.get('/campaign/dashboard-data', {headers: AuthHeader()})
    }

    getCampaignList = () => {
        return axios.get('/campaign/list', {headers: AuthHeader()})
    }
  
    addCampaign: any = (data: any) => {
    return axios.post('/campaign/add', data, {headers: AuthHeader()})
  }
    updateCampaign: any = (data: any) => {
    return axios.put('/campaign/update', data, {headers: AuthHeader()})
  }

    getCampaignById = (id: number) => {
        return axios.get(`/campaign/details/${id}`, {headers: AuthHeader()})
      }

    deleteCampaign = (id: number) => {
        return axios.delete(`/campaign/delete`, {
            data: { id: id },
            headers: AuthHeader(),
        })
    }

    changeCampaignStatus = (id: number) => {
        return axios.put(`/campaign/change-status`, { id: id }, { headers: AuthHeader() })
    }

}

export default new MarketingService()
